"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRenderProps = exports.getListId = exports.getInitialMessage = exports.getImageUrlFormat = void 0;
var _reselect = require("reselect");
var _renderPropsSelector = function _renderPropsSelector(_ref) {
  var renderProps = _ref.renderProps;
  return renderProps;
};
var getRenderProps = exports.getRenderProps = (0, _reselect.createSelector)(_renderPropsSelector, function (renderProps) {
  return renderProps;
});
var getInitialMessage = exports.getInitialMessage = (0, _reselect.createSelector)(getRenderProps, function (_ref2) {
  var initialMessage = _ref2.initialMessage,
    sendInitialMessageDirectly = _ref2.sendInitialMessageDirectly;
  return {
    initialMessage: initialMessage,
    sendInitialMessageDirectly: sendInitialMessageDirectly
  };
});
var getListId = exports.getListId = (0, _reselect.createSelector)(getRenderProps, function (_ref3) {
  var listId = _ref3.listId;
  return listId;
});
var getImageUrlFormat = exports.getImageUrlFormat = (0, _reselect.createSelector)(getRenderProps, function (_ref4) {
  var imageUrlFormat = _ref4.imageUrlFormat;
  return imageUrlFormat;
});